import { PanoramaSelectMenu } from 'shared-ui/components'
import { useLocalization } from 'shared-ui/localization'
import type { Stream } from 'shared-ui/operation-wide-data'
import type { BoundarySource } from 'utils/boundary-autogen'

// Each pass belongs to exactly one source, so its first pass identifies it.
const sourceId = (source: BoundarySource<Stream>) => source.streams[0].streamId

/**
 * Shows which passes an autogenerated boundary was outlined from, and lets the user outline it
 * from a different group instead.
 */
export const BoundarySourcePicker = ({
  sources,
  selected,
  onSelect
}: {
  sources: BoundarySource<Stream>[]
  selected: BoundarySource<Stream>
  onSelect: (source: BoundarySource<Stream>) => void
}) => {
  const { t } = useLocalization()

  const options = sources.map((source) => ({
    id: sourceId(source),
    name: t(($) => $.planning.boundaryCreation.passSource, {
      season: source.season,
      task: t(($) => $.labels.tasks[source.task]),
      count: source.streams.length
    }),
    source
  }))
  const value = options.find(({ id }) => id === sourceId(selected))

  return (
    <PanoramaSelectMenu
      label={t(($) => $.planning.boundaryCreation.createdFrom)}
      size="fill"
      options={options}
      value={value}
      onChange={({ source }) => onSelect(source)}
    />
  )
}
